import { FC, PropsWithChildren } from 'react';
import { CatIconSuccessFilled } from '@blocks-react/components/Icons/SuccessFilled';
import { CatIconSuccessProps } from '../types';
import styles from '../MyEquipment.module.scss';
import { Conditional } from '../../common';

export const MyEquipmentCatIconSuccess: FC<
  PropsWithChildren<CatIconSuccessProps>
> = ({ showIcon }: CatIconSuccessProps) => {
  return (
    <Conditional test={showIcon}>
      <CatIconSuccessFilled
        slot="after"
        data-testid="serial_validation"
        className={styles['cat-icon-success-filled']}
      />
    </Conditional>
  );
};
